/**
 * FilterTraitTypeTrait
 */
import PropTypes from "prop-types";
import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

/**
 * FilterTraitTypeTrait used in FilterTraitType used in TokenTraitFilter
 */
const FilterTraitTypeTrait = (props) => {
  const { trait, inputId, handleChange, selected, amount } = props;
  const onChange = (e) => {
    handleChange(trait, e.target.checked);
  };
  return (
    <FormGroup check>
      <Input type="checkbox" id={inputId} onChange={onChange} defaultChecked={selected} />
      <Label check for={inputId} className="d-flex">
        {trait && <span className="fw-bold">{trait} ({amount})</span>}
      </Label>
    </FormGroup>
  );
};

FilterTraitTypeTrait.propTypes = {
  inputId: PropTypes.string.isRequired,
  trait: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  selected: PropTypes.bool,
  amount: PropTypes.number,
};

/**  define proptype for the 'translation' function  */
FilterTraitTypeTrait.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default FilterTraitTypeTrait;
